import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-import-lokalizacji-bledy-modal',
  templateUrl: './import-lokalizacji-bledy-modal.component.html',
  styleUrls: ['./import-lokalizacji-bledy-modal.component.css']
})
export class ImportLokalizacjiBledyModalComponent implements OnInit {

  listaBledow: Array<string> = new Array();

  constructor(
    public activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    setTimeout(() => {
    });
  }

}
